import React, { useState } from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';
import { Box, Grid } from '@mui/material';
import { assetOptions, componentOptions, escalationOptions, statusOptions, tenantOptions } from '.';
import CustomSelect from './CustomSelect';

const revenueLeasingdata = [
    {
        id: 1,
        sr: 1,
        product: "Fourwrd",
        project: "-",
        warehouseName: "WH1",
        status: "construction yet to start",
        tenantName: "DHL",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 2,
        sr: 2,
        product: "-",
        project: "-",
        warehouseName: "WH2",
        status: "Under construction",
        tenantName: "NA",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 3,
        sr: 3,
        product: "Fourwrd",
        project: "Indore MMLP",
        warehouseName: "WH3",
        status: "Leased, construction yet to commerce",
        tenantName: "Safex",
        plinthAreaSqft: "1,09,227",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 4,
        sr: 4,
        product: "Fourci",
        project: "-",
        warehouseName: "-",
        status: "Leased, construction yet to start",
        tenantName: "-",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 5,
        sr: 5,
        product: "-",
        project: "-",
        warehouseName: "-",
        status: "Leased, underconstruction",
        tenantName: "-",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 6,
        sr: 6,
        product: "-",
        project: "-",
        warehouseName: "-",
        status: "Leased, handed over",
        tenantName: "-",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    },
    {
        id: 7,
        sr: 7,
        product: "-",
        project: "-",
        warehouseName: "-",
        status: "Vacant",
        tenantName: "-",
        plinthAreaSqft: "-",

        lcd1: "-",
        rcd1: "-",
        leaseTenure1: "-",
        rentFree1: "-",
        rental1: "-",
        cam1: "-",
        escalation1: "-",

        lcd2: "-",
        rcd2: "-",
        netEffectiveRental: "-",
        cam2: "-",
        tiRental: "-",
        escalation2: "-",
        leaseTenure2: "-",
        rentFree2: "-",
        lockIn: "-",

        adjustedUnderwritingRental: "-",
        difference: "-"
    }
];


const data = [
    {
        project: "-",
        product: "Fourwrd",
        warehouseName: "WH1",
        status: "Construction yet to start",
        tenantName: "DHL",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "-",

        actual_plinth: "-",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "-",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "Underwriting rental escalated/de-escalated at 5% per year basis diff between underwriting LCD and actual/projected LCD",
        rental_net_effective: "-",
        rental_difference: "-",
    },

    {
        project: "-",
        product: "-",
        warehouseName: "WH2",
        status: "Under Construction",
        tenantName: "NA",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "5% pa",

        actual_plinth: "",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "_",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "-",
        rental_net_effective: "-",
        rental_difference: "-",
    },

    {
        project: "Indore MMLP",
        product: "Forwrd",
        warehouseName: "WH3",
        status: "Leased, construction yet to commence",
        tenantName: "Safex",

        underwriting_plinth: "109227",
        underwriting_lcd: "25 Jan 27",
        underwriting_rcd: "25 Apr 27",
        underwriting_lease_tenure: 180,
        underwriting_rent_free: 3,
        underwriting_rental: 19,
        underwriting_cam: 1,
        underwriting_escalation: "15% every 3 yrs",

        actual_plinth: "1,09,227",
        actual_lcd: "25 Jan 27",
        actual_rcd: "-",
        actual_net_effective: 19,
        actual_cam: 1,
        actual_ti_rental: "-",
        actual_escalation: "15% every 3 yrs",
        actual_lease_tenure: 180,
        actual_rent_free: 3,
        actual_lock_in: 48,

        rental_adjusted_underwriting: 19,
        rental_net_effective: 19,
        rental_difference: "-",
    },

    {
        project: "-",
        product: "FourCi",
        warehouseName: "WH-D4",
        status: "Leased-construction yet to start",
        tenantName: "WH3",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "15% every 3 yrs",

        actual_plinth: "-",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "-",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "-",
        rental_net_effective: "-",
        rental_difference: "-",
    },
    {
        project: "-",
        product: "-",
        warehouseName: "-",
        status: "Leased-handed over",
        tenantName: "-",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "-",

        actual_plinth: "-",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "-",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "-",
        rental_net_effective: "-",
        rental_difference: "-",
    },
    {
        project: "-",
        product: "-",
        warehouseName: "-",
        status: "Leased-handed over",
        tenantName: "-",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "-",

        actual_plinth: "-",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "-",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "-",
        rental_net_effective: "-",
        rental_difference: "-",
    },
    {
        project: "-",
        product: "-",
        warehouseName: "-",
        status: "Vacant",
        tenantName: "-",

        underwriting_plinth: "-",
        underwriting_lcd: "-",
        underwriting_rcd: "-",
        underwriting_lease_tenure: "-",
        underwriting_rent_free: "-",
        underwriting_rental: "-",
        underwriting_cam: "-",
        underwriting_escalation: "-",

        actual_plinth: "-",
        actual_lcd: "-",
        actual_rcd: "-",
        actual_net_effective: "-",
        actual_cam: "-",
        actual_ti_rental: "-",
        actual_escalation: "-",
        actual_lease_tenure: "-",
        actual_rent_free: "-",
        actual_lock_in: "-",

        rental_adjusted_underwriting: "-",
        rental_net_effective: "-",
        rental_difference: "-",
    },
];

const RevenueLeasingNew = () => {
    // const columns = [
    //     { field: "sr", headerName: "#" },
    //     { field: "product", headerName: "Product" },
    //     { field: "project", headerName: "Project" },
    //     { field: "warehouseName", headerName: "Warehouse name" },
    //     { field: "status", headerName: "Status" },
    //     { field: "tenantName", headerName: "Tenant name" },
    //     { field: "plinthAreaSqft", headerName: "Plinth area sqft" },

    //     // First Set
    //     { field: "lcd1", headerName: "LCD" },
    //     { field: "rcd1", headerName: "RCD" },
    //     { field: "leaseTenure1", headerName: "Lease tenure (months)" },
    //     { field: "rentFree1", headerName: "Rent free (months)" },
    //     { field: "rental1", headerName: "Rental INR psf pm (excl CAM excl TI)" },
    //     { field: "cam1", headerName: "CAM INR psf pm" },
    //     { field: "escalation1", headerName: "Escalation" },

    //     // Second Set
    //     { field: "lcd2", headerName: "LCD" },
    //     { field: "rcd2", headerName: "RCD" },
    //     { field: "netEffectiveRental", headerName: "Net effective Rental INR psf pm (excl CAM excl TI)" },
    //     { field: "cam2", headerName: "CAM INR psf pm" },
    //     { field: "tiRental", headerName: "TI rental INR psf pm" },
    //     { field: "escalation2", headerName: "Escalation" },
    //     { field: "leaseTenure2", headerName: "Lease tenure (months)" },
    //     { field: "rentFree2", headerName: "Rent free (months)" },
    //     { field: "lockIn", headerName: "Lock-in (months)" },

    //     // Final Fields
    //     { field: "adjustedUnderwritingRental", headerName: "Adjusted underwriting rental" },
    //     { field: "difference", headerName: "Difference" }
    // ];

    const columnGroups = [
        {
            headerName: "Project",
            field: "project",
        },
        {
            headerName: "Product",
            field: "product",
        },
        {
            headerName: "Warehouse name",
            field: "warehouseName",
        },
        {
            headerName: "Status",
            field: "status",
        },
        {
            headerName: "Tenant name",
            field: "tenantName",
        },
        {
            headerName: "Underwriting",
            children: [
                { field: "underwriting_plinth", headerName: "Plinth Area Sqft" },
                { field: "underwriting_lcd", headerName: "LCD" },
                { field: "underwriting_rcd", headerName: "RCD" },
                { field: "underwriting_lease_tenure", headerName: "Lease Tenure (months)" },
                { field: "underwriting_rent_free", headerName: "Rent Free (months)" },
                { field: "underwriting_rental", headerName: "Rental INR psf pm on plinth excl CAM excl TI" },
                { field: "underwriting_cam", headerName: "CAM INR psf pm on plinth" },
                { field: "underwriting_escalation", headerName: "Escalation" },
            ],
        },
        {
            headerName: "Actual/Projected",
            children: [
                { field: "actual_plinth", headerName: "Plinth area sqft" },
                { field: "actual_lcd", headerName: "LCD" },
                { field: "actual_rcd", headerName: "RCD" },
                { field: "actual_net_effective", headerName: "Net effective Rental INR psf pm on plinth excl CAM excl TI" },
                { field: "actual_cam", headerName: "CAM INR psf pm on plinth" },
                { field: "actual_ti_rental", headerName: "TI rental INR psf pm" },
                { field: "actual_escalation", headerName: "Escalation" },
                { field: "actual_lease_tenure", headerName: "Lease tenure (months)" },
                { field: "actual_rent_free", headerName: "Rent free (months)" },
                { field: "actual_lock_in", headerName: "Lock-in (months)" },
            ],
        },
        {
            headerName: "Rental comparison",
            children: [
                { field: "rental_adjusted_underwriting", headerName: "Adjusted underwriting rental" },
                { field: "rental_net_effective", headerName: "Net effective Rental INR psf pm on plinth excl CAM excl TI" },
                { field: "rental_difference", headerName: "Difference" },
            ]
        },
    ];

    const [revenueFilters, setRevenueFilters] = useState({
        asset: "",
        component: "",
        status: "",
        tenant: "",
        escalation: "",
    });

    const handleRevenueFilterChange = (field, value) => {
        setRevenueFilters((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <>
            <SectionCard title="Revenue & Leasing" description="Asset-wise Rental Performance, Lease Terms & Tenant Analytics">
                <Grid container spacing={2}>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="asset"
                            options={assetOptions}
                            value={revenueFilters.asset}
                            onChange={(e) =>
                                handleRevenueFilterChange("asset", e.value)
                            }
                            placeholder="Asset"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="component"
                            options={componentOptions}
                            value={revenueFilters.component}
                            onChange={(e) =>
                                handleRevenueFilterChange("component", e.value)
                            }
                            placeholder="Components"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="status"
                            options={statusOptions}
                            value={revenueFilters.status}
                            onChange={(e) =>
                                handleRevenueFilterChange("status", e.value)
                            }
                            placeholder="Status"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="tenant"
                            options={tenantOptions}
                            value={revenueFilters.tenant}
                            onChange={(e) =>
                                handleRevenueFilterChange("tenant", e.value)
                            }
                            placeholder="Tenant name"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="escalation"
                            options={escalationOptions}
                            value={revenueFilters.escalation}
                            onChange={(e) =>
                                handleRevenueFilterChange("escalation", e.value)
                            }
                            placeholder="Escalation"
                        />
                    </Grid>

                </Grid>
            </SectionCard>
            <DataTable columns={columnGroups} data={data} />
        </>
    );
}

export default RevenueLeasingNew
